import { isUndefined } from "angular";

editListPickerAnswerController.$inject = ['$scope',
    '$mdDialog',
    '$translate',
    'elementData',
    'elementView'
];
export function editListPickerAnswerController($scope, $mdDialog, $translate, elementData, elementView) {

    $scope.cancel = cancel;
    $scope.removePicture = removePicture;
    $scope.ok = ok;
    init();
    
    function init() {
        $scope.elementData = elementData;
        $scope.elementView = elementView;
        $scope.fileNames = {};
        updateMediaUrls();
        $scope.$watch('fileNames.picture', (newFile) => {
            if (newFile) {
                updatePictureDataURL(newFile);
            }
        });
    }

    function cancel() {
        $mdDialog.cancel();
    }

    function ok() {
        $mdDialog.hide({ type: 'ok', data: $scope.elementData });
    }

    function removePicture() {
        delete $scope.elementData.pictureDataURL;
        updateMediaUrls();
    }

    function updatePictureDataURL(file) {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onloadend = () => {
            $scope.elementData.pictureDataURL = reader.result;
            updateMediaUrls();
        }
    }

    function updateMediaUrls() {
        if ($scope.elementData.pictureDataURL) {
            $scope.bgImage = 'url("' + $scope.elementData.pictureDataURL + '")';
        } else {
            $scope.bgImage = 'none';
        }
    }
}